import React, { useState } from 'react';
import { X } from 'lucide-react';
import Masonry from 'react-masonry-css';
import './Gallery.css';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

const fadeInUp = {
  hidden: { opacity: 0, y: 60 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    { id: 1, url: '/assets/images/14VcWUhFeG5weUzSjNgDQSnKFRq4Z_tPA.jpg', title: 'Farm Dog Training', height: 'tall' },
    { id: 2, url: '/assets/images/14VcWUhFeG5weUzSjNgDQSnKFRq4Z_tPA.jpg', title: 'Working Dog', height: 'medium' },
    { id: 3, url: '/assets/images/1H_8TcD31jAzSUF8QQjLM-MNIsQrm6Zok.jpg', title: 'Ranch Training', height: 'short' },
    { id: 4, url: '/assets/images/1ZELnjtC-34haZirFuXdkfq1aZEdftLhM.jpg', title: 'Livestock Training', height: 'tall' },
    { id: 5, url: '/assets/images/1HOmKO-fAKRT9N62kfi7upqjQW-134LYM.jpg', title: 'Dog Training Session', height: 'medium' },
    { id: 6, url: '/assets/images/14f2nv1_niBBF23AxLlDVHyGp-UC_sJgp.jpg', title: 'Farm Life', height: 'tall' },
    { id: 7, url: '/assets/images/1tpurY4zN36bCxi5MzjbE1cjYMUnQKbTx.jpg', title: 'Training Progress', height: 'short' },
    { id: 8, url: '/assets/images/1dphiVtK9dpZxNgGTq8MhynBAt_sNFs2U.jpg', title: 'Obedience Training', height: 'medium' },
    { id: 9, url: '/assets/images/11WE7aSXvBno1mLmx2Gkgxb7JUXKL7zfN.jpg', title: 'Farm Dog', height: 'tall' },
    { id: 10, url: '/assets/images/12lUtv53vojGdU6XDl5WByhvZlnX9fmPC.jpg', title: 'Dog Handler', height: 'medium' },
    { id: 11, url: '/assets/images/1wIZ1rxeNJENlTYKJKy4X0o8WlztPBmWS.jpg', title: 'Training Day', height: 'short' },
    { id: 12, url: '/assets/images/1pWHSQxTYzdzFeyHi3JWXQ8K_sefF-U2l.jpg', title: 'Farm Skills', height: 'tall' },
    { id: 13, url: '/assets/images/1Q2y2DrVBBb5_QDS4R2UZ3ipP-seGl675.jpg', title: 'Ranch Dog', height: 'medium' },
    { id: 14, url: '/assets/images/1CK1C1D31hHrT2egbyPKC-mkHinzBpi4h.jpg', title: 'Training Success', height: 'tall' },
    { id: 15, url: '/assets/images/1z5gSF5jtyOSWbI11GKsUAA7Jx8Eq_L4B.jpg', title: 'Working Together', height: 'short' },
    { id: 16, url: '/assets/images/1RhZJOH3RVSM2G4njmrZTe1YH_FZJregE.jpg', title: 'Farm Training', height: 'medium' },
    { id: 17, url: '/assets/images/1u70XdR42Xyl2WnJ0DdddVmLuvrG052g7.jpg', title: 'Happy Dogs', height: 'tall' },
    { id: 18, url: '/assets/images/1yyRZIEWCQneDSpo5Ph9DMH68lx2XSVq0.jpg', title: 'Barn Training', height: 'medium' },
    { id: 19, url: '/assets/images/1-tHLWDWWOoYCD_OwWC37Td2F6hpXgeNx.jpg', title: 'Puppy Program', height: 'short' },
    { id: 20, url: '/assets/images/16f0JG5nBJRiv5R4XvE8XIIrwMtwOCBOF.jpg', title: 'Young Dog', height: 'tall' },
    { id: 21, url: '/assets/images/1xbCjOu7fp4NAoDzj8o9w7RaZNkhEmDUK.jpg', title: 'Training Session', height: 'medium' },
    { id: 22, url: '/assets/images/1Pw7q0yXJJNSG7YIfUj57esF8H6RALYsH.jpg', title: 'Farm Dog Oklahoma', height: 'tall' },
    { id: 23, url: '/assets/images/1hWpv-vQzlbUOytoqlY531kSd9vILeNge.jpg', title: 'Dog & Livestock', height: 'short' },
    { id: 24, url: '/assets/images/176tFouaUHThgejD5V_2efNuR--54xLxZ.jpg', title: 'Training Adventures', height: 'medium' },
    { id: 25, url: '/assets/images/168Rz07VLMwzuhlBhMyUljWBDRUCs8iFm.jpg', title: 'Ranch Life', height: 'tall' },
    { id: 26, url: '/assets/images/1TE5lj7eHyYOXuU-ui5oF_WSy7BjZC8bP.jpg', title: 'Working on Farm', height: 'medium' },
    { id: 27, url: '/assets/images/1VGjOANhIryUbiZWr9R-k06mbOIzHDgBr.jpg', title: 'Dog Training', height: 'short' },
    { id: 28, url: '/assets/images/1AxG1zeYZ8tbebanC_u5UjiZ-zFWOLoI4.jpg', title: 'Farm Adventures', height: 'tall' },
    { id: 29, url: '/assets/images/1KOmnYrHH6jUZ_q4PxDW0FGJIq_F0mTHf.jpg', title: 'Training Day', height: 'medium' },
    { id: 30, url: '/assets/images/1kdADlALYBQcgGb_BDepRteicQ6qsBE7K.jpg', title: 'Skilled Farm Dog', height: 'tall' },
    { id: 31, url: '/assets/images/1hKCOc3HD4CgJbnTMH_e48jMTY_i8Wdo-.jpg', title: 'Ranch Training', height: 'short' },
    { id: 32, url: '/assets/images/1EJJNLBM3doobqURhq3ibxu_WnnyKkVhr.jpg', title: 'Dog & Handler', height: 'medium' },
    { id: 33, url: '/assets/images/1eKLzBjlg2Z13QmfcYC5Y-NEL5sHKNXk5.jpg', title: 'Training Progress', height: 'tall' },
    { id: 34, url: '/assets/images/1hmnNya2QGg0soCDALjOipfkt75KVckxl.jpg', title: 'Farm Life', height: 'medium' },
    { id: 35, url: '/assets/images/1S8jBw_z6Fy6CCVVLqF--H2kt00jnWOS2.jpg', title: 'Obedience Work', height: 'short' },
    { id: 36, url: '/assets/images/1euWO_oJ4dAqoWahE8LN90N98x3pvKrfL.jpg', title: 'Working Dog', height: 'tall' },
    { id: 37, url: '/assets/images/1BWP-y8UBO4S6jNeb6vDECY2H9TfZsVZZ.jpg', title: 'Farm Training', height: 'medium' },
    { id: 38, url: '/assets/images/1MjwPBQTMm3uKMN7LlA2RzVSJg3iPuDIj.jpg', title: 'Training Success', height: 'tall' },
    { id: 39, url: '/assets/images/1zPkwohDG8pC63IH0faVGC20jr4oXtS3i.jpg', title: 'Ranch Dog', height: 'short' },
    { id: 40, url: '/assets/images/1BT7LJhgtIPDmE3C6dhTjF7N8FIkwxhI4.jpg', title: 'Dog Skills', height: 'medium' },
    { id: 41, url: '/assets/images/1SK4u4pTthall32kDddyPkJwLtlVv5QYQ.jpg', title: 'Farm Dog', height: 'tall' },
    { id: 42, url: '/assets/images/1X463ggRfDZFDmen1zAeaPhF-JnNLCv-y.jpg', title: 'Training Session', height: 'medium' },
    { id: 43, url: '/assets/images/1JcYMRF1roWoOHx7hgK-LdmZfv2zybAn8.jpg', title: 'Livestock Work', height: 'short' },
    { id: 44, url: '/assets/images/1Ls11yKebKwhmxsD94ERwY82Muu11tCWT.jpg', title: 'Farm Adventures', height: 'tall' },
    { id: 45, url: '/assets/images/1oeTgGiZqhhV_QIuOkzLeVYBFAlJ57gm-.jpg', title: 'Dog Training', height: 'medium' },
    { id: 46, url: '/assets/images/10gDSYA1UHc7E9jUfFZZ2AHbr_KLZZy30.jpg', title: 'Ranch Training', height: 'tall' },
    { id: 47, url: '/assets/images/1_De7KmB_kUsCVHaof0WgT-bf8Rx5nIjw.jpg', title: 'Working Together', height: 'short' },
    { id: 48, url: '/assets/images/1I4lNun7hoqYnDahju_aHcOImTvGxJWJ-.jpg', title: 'Farm Life', height: 'medium' },
    { id: 49, url: '/assets/images/1yGD12nYJ9PfRAwV0WqVtEG2OAcTXVBlX.jpg', title: 'Training Day', height: 'tall' },
    { id: 50, url: '/assets/images/1CMXoQmPDkPCImtoihqlujpVaXreZ2VIT.jpg', title: 'Farm Dog Oklahoma', height: 'medium' },
  ];

  const breakpointColumns = {
    default: 4,
    1400: 3,
    1000: 2,
    700: 1
  };

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Photo Gallery — Farm Dog Oklahoma | Dog Training Photos Tulsa OK</title>
        <meta name="description" content="Browse photos from Farm Dog Oklahoma training sessions. See real results from our board & train, puppy programs, and farm dog training in Tulsa and surrounding Oklahoma areas." />
        <link rel="canonical" href="https://farmdogoklahoma.com/gallery" />
        <meta property="og:title" content="Photo Gallery — Farm Dog Oklahoma" />
        <meta property="og:description" content="See real training photos and results from Farm Dog Oklahoma." />
        <meta property="og:url" content="https://farmdogoklahoma.com/gallery" />
      </Helmet>
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#5C4033] to-[#3E2723] py-20">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#C4A052] rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#C4A052] rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Gallery
            </h1>
            <p className="text-xl md:text-2xl text-[#C4A052] font-semibold">
              See Our Dogs in Action
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <motion.section className="section-padding bg-white" initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} variants={fadeInUp}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#5C4033] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Our Training Success Stories
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Browse through photos of our dogs learning, growing, and thriving in their farm environments.
            </p>
          </div>

          {/* Pinterest-style Masonry Grid */}
          <Masonry
            breakpointCols={breakpointColumns}
            className="masonry-grid"
            columnClassName="masonry-grid-column"
          >
            {galleryImages.map((image) => (
              <div
                key={image.id}
                className="masonry-item group cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-2xl transition-all duration-300"
                onClick={() => setSelectedImage(image)}
              >
                <div className="relative w-full overflow-hidden">
                  <img
                    src={image.url}
                    alt={image.title}
                    className="w-full h-auto transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <p className="text-white font-semibold text-sm md:text-base">
                        {image.title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Masonry>

          {/* Note about photos */}
          <div className="mt-16 text-center bg-[#F5F5F0] rounded-lg p-8">
            <p className="text-gray-700 text-lg mb-4">
              Follow us on social media for more photos and daily updates!
            </p>
            <div className="flex justify-center gap-6">
              <a
                href="https://www.facebook.com/profile.php?id=100092500893371"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#C4A052] hover:text-[#B8935E] font-semibold transition-colors text-lg"
              >
                Facebook
              </a>
              <span className="text-gray-400 text-lg">•</span>
              <a
                href="https://www.instagram.com/farmdogok/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#C4A052] hover:text-[#B8935E] font-semibold transition-colors text-lg"
              >
                Instagram
              </a>
            </div>
          </div>
        </div>
      </motion.section>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 animate-fadeIn"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-[#C4A052] transition-colors z-10"
            onClick={() => setSelectedImage(null)}
          >
            <X size={40} strokeWidth={2} />
          </button>
          <div className="max-w-7xl max-h-[90vh] relative animate-scaleIn">
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-lg">
              <p className="text-white text-center text-xl font-semibold">
                {selectedImage.title}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
